function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.494,5.345h2.79a.665.665,0,0,0,0-1.33h-2.79a.665.665,0,0,0,0,1.33Z",
  transform: "translate(0.001 -1)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M6.506,9.488H3.716a.665.665,0,1,0,0,1.33h2.79a.665.665,0,1,0,0-1.33Z",
  transform: "translate(0.001 -1)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.93,15.92a2.235,2.235,0,0,0-2.68-1.59l-6.42,1.76a.381.381,0,0,1-.15.01l-2.77-.43.46-.21a2.318,2.318,0,0,0,1.25-1.63h8.5a.875.875,0,0,0,.88-.88V1.88A.875.875,0,0,0,22.12,1H1.88A.875.875,0,0,0,1,1.88V12.95a.875.875,0,0,0,.88.88H3.16L.3,15.69a.662.662,0,0,0-.19.92.664.664,0,0,0,.92.2l4.58-2.98.17-.11a.222.222,0,0,1,.11-.05l5.03-1.17.26-.06a.917.917,0,0,1,.57.06.89.89,0,0,1,.51.48.941.941,0,0,1-.03.85.965.965,0,0,1-.44.43L9.39,15.4a.664.664,0,0,0,.18,1.26l4.91.75a1.505,1.505,0,0,0,.7-.04l6.41-1.75a.877.877,0,0,1,1.05.63.89.89,0,0,1-.54,1.06l-7.16,2.74a.345.345,0,0,1-.17.02l-6.38-.76a1.943,1.943,0,0,0-.72.07L.46,21.7a.674.674,0,0,0-.43.84A.663.663,0,0,0,.66,23a.761.761,0,0,0,.21-.03l7.21-2.32a.389.389,0,0,1,.15-.02l6.38.76a1.673,1.673,0,0,0,.8-.1l7.16-2.74A2.216,2.216,0,0,0,23.93,15.92ZM10.89,11.14l-5.3,1.23a1.476,1.476,0,0,0-.35.13H2.33V2.33H21.67V12.5H13.5c-.01-.02-.02-.05-.03-.07A2.307,2.307,0,0,0,10.89,11.14Z",
  transform: "translate(0.001 -1)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(10.999 5.18)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.001,
    height: 22,
    viewBox: "0 0 24.001 22"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/loan.8ed00732.svg";
export { SvgComponent as ReactComponent };